/*
@author govind dindewad
*/
import axios from "axios";
import apiUrl from "./api";

/*
/ @author govind dindewad
/ dt:- 01-03-2025
/ Function to get the list of complaints based on various search parameters
*/
async function getComplaintList({ searchKey = '', complaintType = 'All', status = 'All', userType = false, pageNo = 0 }) {
    // Retrieving the authentication token from localStorage for authorization
    const token = window.localStorage.getItem('token');

    try {
        // Sending a GET request to the API with dynamic query parameters for search filters
        const response = await axios.get(`${apiUrl}secure/complaint/retain-all-complaint?searchKey=${searchKey}&status=${status === 'All' ? "null" : status}&complaintType=${complaintType === 'All' ? "null" : complaintType}&userType=${userType === 'All' ? "null" : userType}&pageNumber=${pageNo}`, {
            // Adding the Authorization header with the token for secure API access
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });

        // Returning the successful response from the API
        return response;

    } catch (error) {
        if (error?.message === 'Network Error') {
            return {
                status: 301,
                message: 'Network Error'
            }
        }
        // Handling errors by returning the error response (in case of failure)
        return error.response;
    }
}

/*
/ @author govind dindewad
/ dt:- 03-03-2025
/ Function to get the details of a complaint based on the complaint id
*/
async function getComplaintDetails(complaint) {
    // Retrieving the authentication token from localStorage for authorization
    const token = window.localStorage.getItem('token');

    try {
        // Sending a GET request to the API with the complaintId to fetch complaint details
        const response = await axios.get(`${apiUrl}secure/complaint/retain-complaint?complaintId=${complaint.complaintId}`, {
            // Adding the Authorization header with the token for secure API access
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });

        // Returning the successful response from the API
        return response;

    } catch (error) {
        if (error?.message === 'Network Error') {
            return {
                status: 301,
                message: 'Network Error'
            }
        }
        // Handling errors by returning the error response (in case of failure)
        return error.response;
    }
}

/*
/ @author govind dindewad
/ dt:- 03-03-2025
/ Function to fetch chat messages related to a specific complaint
*/
async function getComplaintChats(complaintId = '', userId = '') {
    // Retrieving the authentication token from localStorage for authorization
    const token = window.localStorage.getItem('token');

    try {
        // Sending a GET request to the API to fetch chat messages for a specific complaintId and userId
        const response = await axios.get(`${apiUrl}secure/chat-messages/user-complaints?complaintId=${complaintId}&userId=${userId}`, {
            // Adding the Authorization header with the token for secure API access
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });

        // Returning the successful response from the API
        return response;

    } catch (error) {
        if (error?.message === 'Network Error') {
            return {
                status: 301,
                message: 'Network Error'
            }
        }
        // Handling errors by returning the error response (in case of failure)
        return error.response;
    }
}

/*
/ @author govind dindewad
/ dt:- 03-03-2025
/ Function to update the complaint chat with a new message
*/
async function updateComplaintChat(groupChatRoomId = '', userId = '', chatMessage) {
    // Retrieving the authentication token from localStorage for authorization
    const token = window.localStorage.getItem('token');

    try {
        // Sending a PATCH request to the API to add a new message to the chat related to a complaint
        const response = await axios.patch(`${apiUrl}secure/chat-message/reply?groupChatRoomId=${groupChatRoomId}&userId=${userId}`, { chatMessage: chatMessage }, {
            // Adding the Authorization header with the token for secure API access
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });

        // Returning the successful response from the API
        return response;

    } catch (error) {
        if (error?.message === 'Network Error') {
            return {
                status: 301,
                message: 'Network Error'
            }
        }
        // Handling errors by returning the error response (in case of failure)
        return error.response;
    }
}

/*
/ @author govind dindewad
/ dt:- 03-03-2025
/ Function to process a refund for a specific complaint
*/
async function updateRefund(complaintId = '', amount = '', userId) {
    // Retrieving the authentication token from localStorage for authorization
    const token = window.localStorage.getItem('token');

    try {
        // Sending a POST request to process the refund for a specific complaint
        const response = await axios.post(`${apiUrl}secure/complaint/refund`, { complaintId: complaintId, amount: amount, userId: userId }, {
            // Adding the Authorization header with the token for secure API access
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });

        // Returning the successful response from the API
        return response;

    } catch (error) {
        if (error?.message === 'Network Error') {
            return {
                status: 301,
                message: 'Network Error'
            }
        }
        // Handling errors by returning the error response (in case of failure)
        return error.response;
    }
}

/*
/ @author govind dindewad
/ dt:- 03-03-2025
/ Function to update the complaint status (e.g., close, open)
*/
async function updateComplaintStatus(complaintId = '', complaintStatus = "close", userId) {
    // Retrieving the authentication token from localStorage for authorization
    const token = window.localStorage.getItem('token');

    try {
        // Sending a PATCH request to update the complaint status (e.g., close or resolve it)
        const response = await axios.patch(`${apiUrl}secure/complaint/update-complaint`, { complaintId: complaintId, complaintStatus: complaintStatus, userId: userId }, {
            // Adding the Authorization header with the token for secure API access
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });

        // Returning the successful response from the API
        return response;

    } catch (error) {
        if (error?.message === 'Network Error') {
            return {
                status: 301,
                message: 'Network Error'
            }
        }
        // Handling errors by returning the error response (in case of failure)
        return error.response;
    }
}

// Exporting all the functions for use in other modules
export { getComplaintList, getComplaintDetails, getComplaintChats, updateComplaintChat, updateRefund, updateComplaintStatus };
